import styled from 'styled-components';

export const MessagesList = styled.div`
  padding: 10px 0 0 0;
  max-height: 300px;
  overflow-y: scroll;
`;

export const CommentMessage = styled.div`
  font-size: 14px;
  margin-bottom: 5px;

  &:last-child {
    margin-bottom: 0;
  }

  .comment-message-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 4px;
    font-size: 14px;
    color: ${({ theme }) => theme.colors.common.grey};

    h4 {
      color: ${({ theme }) => theme.colors.common.blue};
      font-size: 14px;
      margin-bottom: 0;
    }

    span {
      margin-left: auto;
      margin-right: 5px;
    }

    button {
      display: flex;
      align-items: center;
      justify-content: center;
      padding: 3px;
    }
  }

  p {
    color: ${({ theme }) => theme.colors.common.grey500};
  }

  textarea {
    min-height: 100px;
    width: 97%;
  }
`;

export const EditCommentBtn = styled.button`
  color: ${({ theme }) => theme.colors.common.grey};
  margin-right: 2px;
`;
